export enum VenuesShoppingCartModalStage {
    INQUIRY_FORM = 1,
    SUCCESS,
    RECOMMENDATIONS,
    GUEST_ROOMS,
}
